<!-- Mobile Toast -->
<div
  class="mobile-toast"
  *ngIf="platform === PlatformEnum.mobile"
  data-cy="mobile-toast"
>
  <ion-icon
    name="checkmark-circle"
    class="toast-icon"
    data-cy="toast-icon"
  ></ion-icon>
  <span class="toast-message" data-cy="toast-message">{{
    'i18n.imageOrderingPage.successOrderMessage' | translate
  }}</span>
</div>

<!-- File Accordion Section -->
<ion-accordion-group
  data-cy="file-accordion-group"
  [value]="getExpandedAccordions()"
  multiple="true"
>
  <ion-accordion
    *ngFor="let group of productGroups; trackBy: trackByGroupId"
    [value]="group.fileName + '-' + group.imageId"
    toggleIcon="none"
    toggleIconSlot="none"
    data-cy="file-accordion"
  >
    <ion-item slot="header" data-cy="accordion-header">
      <ion-label data-cy="file-name-label">
        {{
          group.fileName || 'i18n.imageOrderingPage.noFileName' | translate
        }}({{ group.products.length }})
        <ion-icon
          name="chevron-down"
          class="custom-chevron"
          data-cy="chevron-icon"
        ></ion-icon>
      </ion-label>
    </ion-item>

    <div class="ion-padding" slot="content" data-cy="accordion-content">
      <!-- Desktop/Tablet Table -->
      <div
        class="table-container desktop"
        *ngIf="
          platform === PlatformEnum.desktop || platform === PlatformEnum.tablet
        "
        data-cy="desktop-table-container"
      >
        <table class="products-table" data-cy="products-table">
          <thead data-cy="table-head">
            <tr class="table-header" data-cy="table-header-row">
              <th class="row-header" data-cy="row-number-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{ 'i18n.imageOrderingPage.rowNumber' | translate }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.ROW_NUMBER)"
                    [class.active]="isSortActive(group, SortColumn.ROW_NUMBER)"
                    data-cy="row-number-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(group, SortColumn.ROW_NUMBER) ===
                        SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(group, SortColumn.ROW_NUMBER) ===
                        SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="product-number-header" data-cy="product-number-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{
                      'i18n.imageOrderingPage.detectedProductNumber' | translate
                    }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.PRODUCT_NUMBER)"
                    [class.active]="
                      isSortActive(group, SortColumn.PRODUCT_NUMBER)
                    "
                    data-cy="product-number-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(group, SortColumn.PRODUCT_NUMBER) ===
                        SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(group, SortColumn.PRODUCT_NUMBER) ===
                        SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="product-name-header" data-cy="product-name-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{ 'i18n.imageOrderingPage.detectedProducts' | translate }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.PRODUCT_NAME)"
                    [class.active]="
                      isSortActive(group, SortColumn.PRODUCT_NAME)
                    "
                    data-cy="product-name-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(group, SortColumn.PRODUCT_NAME) ===
                        SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(group, SortColumn.PRODUCT_NAME) ===
                        SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="quantity-header" data-cy="quantity-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{ 'i18n.imageOrderingPage.detectedQuantity' | translate }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.DETECTED_QUANTITY)"
                    [class.active]="
                      isSortActive(group, SortColumn.DETECTED_QUANTITY)
                    "
                    data-cy="quantity-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(
                          group,
                          SortColumn.DETECTED_QUANTITY
                        ) === SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(
                          group,
                          SortColumn.DETECTED_QUANTITY
                        ) === SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="quantity-type-header" data-cy="quantity-type-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{
                      'i18n.imageOrderingPage.detectedQuantityType' | translate
                    }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.QUANTITY_TYPE)"
                    [class.active]="
                      isSortActive(group, SortColumn.QUANTITY_TYPE)
                    "
                    data-cy="quantity-type-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(group, SortColumn.QUANTITY_TYPE) ===
                        SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(group, SortColumn.QUANTITY_TYPE) ===
                        SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="match-header" data-cy="match-header">
                <div class="header-content">
                  <div class="row-header-text">
                    {{ 'i18n.imageOrderingPage.match' | translate }}
                  </div>
                  <div
                    class="caret-icon"
                    (click)="handleSort(group, SortColumn.MATCH)"
                    [class.active]="isSortActive(group, SortColumn.MATCH)"
                    data-cy="match-sort"
                  >
                    <ion-icon
                      name="caret-up-outline"
                      [class.active]="
                        getSortDirection(group, SortColumn.MATCH) ===
                        SortDirection.ASC
                      "
                    ></ion-icon>
                    <ion-icon
                      name="caret-down-outline"
                      class="caret-down"
                      [class.active]="
                        getSortDirection(group, SortColumn.MATCH) ===
                        SortDirection.DESC
                      "
                    ></ion-icon>
                  </div>
                </div>
              </th>
              <th class="actions-header" data-cy="actions-header">
                <div class="row-header-text">
                  {{ 'i18n.imageOrderingPage.actions' | translate }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody data-cy="table-body">
            <tr
              class="product-row"
              *ngFor="let product of group.products; trackBy: trackByRowNumber"
              data-cy="product-row"
            >
              <td class="row-cell" data-cy="row-number-cell">
                {{ product.rowNumber }}
              </td>
              <td class="product-number-cell" data-cy="product-number-cell">
                {{ product.productNumber }}
              </td>
              <td class="product-name-cell" data-cy="product-name-cell">
                {{ product.productName }}
              </td>
              <td class="quantity-cell" data-cy="quantity-cell">
                <ion-input
                  type="number"
                  class="quantity-input"
                  data-cy="quantity-input"
                  [value]="product.detectedQuantity"
                  (ionChange)="
                    handleQuantityChange(
                      group.imageId,
                      product.matchedProductNumber,
                      +$event.detail.value,
                      product.quantityType
                    )
                  "
                  [disabled]="!product.isEditable"
                >
                </ion-input>
              </td>
              <td class="quantity-type-cell" data-cy="quantity-type-cell">
                {{ product.quantityType }}
              </td>
              <td class="match-cell" data-cy="match-cell">
                <span [class.red-text]="!product.isEditable">
                  {{ product.matchDescription }}
                </span>
              </td>
              <td class="actions-cell" data-cy="actions-cell">
                <ion-button
                  fill="clear"
                  (click)="
                    handleDeleteProduct(
                      group.imageId,
                      product.matchedProductNumber
                    )
                  "
                  data-cy="delete-product-button"
                  *ngIf="product.isEditable"
                >
                  <ion-icon
                    name="trash"
                    slot="icon-only"
                    data-cy="delete-icon"
                  ></ion-icon>
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Cards -->
      <div
        class="cards-container"
        *ngIf="platform === PlatformEnum.mobile"
        data-cy="mobile-cards-container"
      >
        <div
          class="mobile-product-card"
          *ngFor="let product of group.products; trackBy: trackByRowNumber"
          data-cy="product-card"
        >
          <!-- Card Header -->
          <div class="mobile-card-header" data-cy="mobile-card-header">
            <span class="row-number" data-cy="mobile-row-number">
              {{ 'i18n.imageOrderingPage.rowNumber' | translate }}
              {{ product.rowNumber }}
            </span>
            <ion-button
              fill="clear"
              color="success"
              (click)="
                handleDeleteProduct(group.imageId, product.matchedProductNumber)
              "
              [style.visibility]="product.isEditable ? 'visible' : 'hidden'"
              data-cy="delete-product-button-mobile"
            >
              <ion-icon
                name="trash"
                slot="icon-only"
                data-cy="delete-icon-mobile"
              ></ion-icon>
            </ion-button>
          </div>

          <!-- First Row: Product # | Products | Qty -->
          <div class="mobile-row" data-cy="mobile-first-row">
            <div
              class="mobile-column product-other-column"
              data-cy="mobile-product-number-column"
            >
              <div class="mobile-label" data-cy="mobile-product-number-label">
                {{ 'i18n.imageOrderingPage.detectedProduct#' | translate }}
              </div>
              <div class="mobile-value" data-cy="mobile-product-number-value">
                {{ product.productNumber }}
              </div>
            </div>
            <div
              class="mobile-column product-other-column"
              data-cy="mobile-product-name-column"
            >
              <div class="mobile-label" data-cy="mobile-product-name-label">
                {{ 'i18n.imageOrderingPage.detectedProducts2' | translate }}
              </div>
              <div class="mobile-value" data-cy="mobile-product-name-value">
                {{ product.productName }}
              </div>
            </div>
            <div
              class="mobile-column quantity-column"
              data-cy="mobile-quantity-column"
            >
              <div class="mobile-label" data-cy="mobile-quantity-label">
                {{ 'i18n.imageOrderingPage.detectedQty' | translate }}
              </div>
              <div class="mobile-value" data-cy="mobile-quantity-value">
                <ion-input
                  type="number"
                  class="quantity-input-mobile"
                  data-cy="quantity-input-mobile"
                  [value]="product.detectedQuantity"
                  (ionChange)="
                    handleQuantityChange(
                      group.imageId,
                      product.matchedProductNumber,
                      +$event.detail.value,
                      product.quantityType
                    )
                  "
                  [disabled]="!product.isEditable"
                >
                </ion-input>
              </div>
            </div>
          </div>

          <!-- Second Row: Qty Type | Match -->
          <div class="mobile-row" data-cy="mobile-second-row">
            <div
              class="mobile-column product-other-column"
              data-cy="mobile-quantity-type-column"
            >
              <div class="mobile-label" data-cy="mobile-quantity-type-label">
                {{ 'i18n.imageOrderingPage.detectedQtyType' | translate }}
              </div>
              <div class="mobile-value" data-cy="mobile-quantity-type-value">
                {{ product.quantityType }}
              </div>
            </div>
            <div
              class="mobile-column-wide match-column"
              data-cy="mobile-match-column"
            >
              <div class="mobile-label" data-cy="mobile-match-label">
                {{ 'i18n.imageOrderingPage.match' | translate }}
              </div>
              <div class="mobile-value" data-cy="mobile-match-value">
                <div
                  class="match-content-wrapper"
                  [id]="
                    'desc-trigger-' + product.rowNumber + '-' + group.imageId
                  "
                  *ngIf="
                    isLongDescription(product.matchDescription);
                    else shortDescription
                  "
                >
                  <span
                    [class.red-text]="!product.isEditable"
                    class="match-description"
                  >
                    {{ product.matchDescription }}
                  </span>
                  <ion-icon
                    class="info-icon"
                    name="information-circle"
                    data-cy="info-icon-mobile"
                  ></ion-icon>
                </div>
                <ng-template #shortDescription>
                  <span [class.red-text]="!product.isEditable">
                    {{ product.matchDescription }}
                  </span>
                </ng-template>
                <ion-popover
                  *ngIf="isLongDescription(product.matchDescription)"
                  [trigger]="
                    'desc-trigger-' + product.rowNumber + '-' + group.imageId
                  "
                  triggerAction="hover"
                  class="info-popover"
                  data-cy="info-popover-mobile"
                  [arrow]="true"
                  side="top"
                  alignment="center"
                >
                  <ng-template>
                    <div class="popover-content" data-cy="popover-content">
                      {{ product.matchDescription }}
                    </div>
                  </ng-template>
                </ion-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-accordion>
</ion-accordion-group>
